/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getAllTasks = () => {
  return API.get(`${getApiUrl()}/api/task/get-all`);
}

export const getBotTasks = (taskIds) => {
  return API.get(`${getApiUrl()}/api/task/get/${taskIds}`);
}

export const updateTasks = (tasks) => {
  return API.post(`${getApiUrl()}/api/task`, tasks);
}

export const getLogs = (query) => {
  var {task_id, from_time} = query;
  var strQuery = `task_id=${task_id}`;

  if (from_time)
    strQuery += `&time>${from_time}`;    

  return API.get(`${getApiUrl()}/api/log?${strQuery}`);
}

export const taskService = {
  getBotTasks,
  getAllTasks,
  getLogs,
  updateTasks
}
